import { cva } from "class-variance-authority"

const iconSize = {
  medium: "size-5",
  large: "size-6",
}

const labelSize = {
  medium: "font-medium-400",
  large: "font-large-400",
}

export type CheckboxSize = keyof typeof iconSize

export const checkboxSizeKeys = Object.keys(iconSize) as CheckboxSize[]

export const checkboxContainerVariants = cva(
  "relative inline-flex w-fit cursor-pointer items-start gap-x-2 has-[:disabled]:cursor-not-allowed"
)

export const checkboxIconVariants = cva(
  "text-icon-general-secondary peer-checked:text-icon-general-primary peer-indeterminate:text-icon-general-primary peer-disabled:text-icon-general-disabled shrink-0 rounded-xs",
  {
    variants: {
      size: iconSize,
      focusRing: {
        true: "peer-focus-visible:outline-semantic-interaction-selected peer-focus-visible:outline peer-focus-visible:outline-1 peer-focus-visible:outline-offset-2",
        false: "",
      },
      error: {
        true: "text-icon-general-error",
      },
    },
    defaultVariants: {
      size: "medium",
      focusRing: true,
    },
  }
)

export const checkboxLabelVariants = cva(
  "text-icon-general-secondary peer-checked:text-icon-general-primary peer-indeterminate:text-icon-general-primary peer-disabled:text-icon-general-disabled",
  {
    variants: {
      size: labelSize,
    },
    defaultVariants: {
      size: "medium",
    },
  }
)
